import { Injectable } from '@angular/core';
import { Apollo, gql, Query } from 'apollo-angular';
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };

// Escrita à mão (o codegen aponta para um host fora do ar): anexos da ideia
// tradicional para o detalhe. Não usa o fragment `Idea` compartilhado.

export type IdeaFileItem = {
  id: string;
  fileName?: string | null;
  originalName?: string | null;
  createdAt?: any | null;
};

export type GetIdeaFilesQuery = {
  getIdea: { id: string; status: string; canManageFiles: boolean; ideafiles?: Array<IdeaFileItem> | null };
};
export type GetIdeaFilesQueryVariables = Exact<{
  id: string;
}>;

export const GetIdeaFilesDocument = gql`
    query GetIdeaFiles($id: String!) {
  getIdea(id: $id) {
    id
    status
    canManageFiles
    ideafiles {
      id
      fileName
      originalName
      createdAt
    }
  }
}
    `;

@Injectable({
  providedIn: 'root'
})
export class GetIdeaFilesGQL extends Query<GetIdeaFilesQuery, GetIdeaFilesQueryVariables> {
  document = GetIdeaFilesDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}
